import React from 'react';
import styled from 'styled-components';
import {D} from './design-tokens';

export type KeyValueRow = {key: string; value: string};

const Table = styled.div`
	display: flex;
	flex-direction: column;
	width: 100%;
`;

const Row = styled.div`
	display: flex;
	gap: 8px;
	align-items: center;
	padding: 2px 0;
	border-bottom: 1px solid ${D.assistantBubbleBorder};
	&:last-child {
		border-bottom: none;
	}
`;

const Key = styled.div`
	min-width: 100px;
	font-size: 10px;
	line-height: 14px;
	letter-spacing: 0.3px;
	color: ${D.v2.textSecondary};
`;

const Value = styled.div`
	flex: 1 0 0;
	font-size: 14px;
	line-height: 20px;
	letter-spacing: 0.15px;
	color: ${D.v2.textPrimary};
`;

// Stable seam: TNSR-245 drops editable DS inputs in here, keeping the `rows` prop shape.
export function KeyValueTable({rows}: {rows: KeyValueRow[]}): JSX.Element | null {
	if (rows.length === 0) return null;
	return (
		<Table>
			{rows.map(r => (
				<Row key={r.key}>
					<Key>{r.key}</Key>
					<Value>{r.value}</Value>
				</Row>
			))}
		</Table>
	);
}
